import {Component, Input} from "@angular/core";
import {EditService} from "../../framework/entity/edit/edit-page/edit.service";
import {ContactData} from "../contact.data";
import {FormGroup} from "@angular/forms";

@Component({
    selector: "wbo-contact-edit",
    templateUrl: "./contact-edit.component.html"
})
export class ContactEditComponent {

    @Input() formGroupContact: FormGroup;
    @Input() contact: ContactData;

    /**
     * Indicates that only the essential contact details are shown
     */
    @Input() minimal: boolean = false;

    constructor(public editService: EditService) {
    }
}
